// @generated
// This file is automatically generated by Kanel. Do not modify manually.

/** Represents the enum public.method_multitest */
enum MethodMultitest {
  bonferroni = 'bonferroni',
  sidak = 'sidak',
  'holm-sidak' = 'holm-sidak',
  holm = 'holm',
  'simes-hochberg' = 'simes-hochberg',
  hommel = 'hommel',
  fdr_bh = 'fdr_bh',
};

export default MethodMultitest;
